import { Navigate, useLocation } from "react-router-dom";
import { useCart } from "../CartContext";

const ProtectedRoute = ({ children, restricted = false }) => {
    const isUnlocked = localStorage.getItem("unlocked") === "true"; // Check unlock status
    const checkoutAllowed = localStorage.getItem("checkoutAllowed") === "true"; // Checkout access
    const { cart } = useCart();
    const location = useLocation(); // Get current page

    // 🔹 If page is locked, prevent access to all pages (except "/")
    if (!isUnlocked && location.pathname !== "/") {
        return <Navigate to="/" replace />;
    }

    // 🔹 If trying to access restricted pages (/checkout, /order-confirmation) → Redirect to cart + If cart is empty
    if (isUnlocked && restricted && (!checkoutAllowed || cart.length === 0)) {
        alert("Access Denied!");
        return <Navigate to="/cart" replace />;
    }

    return children; // ✅ Allow access if all checks pass
};

export default ProtectedRoute;
